export const removeNonNumeric = number => {
  const numberStr = number.toString();

  return numberStr.replace(/[^\d.-]/g, '');
};
